import { Logger, ServiceType } from "@lib/monitoring/logger";

declare const grecaptcha;

export const getRecaptchaToken = async (action: string): Promise<string | null> => {
    try {
        // Ensure grecaptcha is ready
        await new Promise<void>((resolve) => {
            grecaptcha.enterprise.ready(() => {
                resolve(); // Resolve when grecaptcha is ready
            });
        });

        return await grecaptcha.enterprise.execute(process.env.NEXT_PUBLIC_RECAPTCHA_TOKEN, {
            action,
        });
    } catch (error) {
        Logger.error(ServiceType.RECAPTCHA, "Error occurred while executing reCAPTCHA", error);
        return null;
    }
};
